<script>
  import { Pie, mixins } from 'vue-chartjs'
  const { reactiveProp } = mixins

  export default {
    extends: Pie,
    mixins: [reactiveProp],
    props: {
      chartData: {
        type: Object,
        default: {}
      },         
    },    
    data() {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: true,
          scales: {        
            xAxes: [{
              display: false,
              scaleLabel: {
                display: false,                
              },
              ticks: {
                beginAtZero: false,
                max: 100
              }               
            }],                    
            yAxes: [{
              display: false,                                    
              ticks: {
                beginAtZero: false,
                max: 100,
              }
            }]
          }
        }
      }
    },       
    mounted () {        
      this.render()
    },
    watch: {
      chartData: function() {        
        this.$data._chart.update()
      },
    }, 
    methods: {
      render() {
        this.renderChart(this.chartData, this.options) 
      }
    }
  }
</script>

